import UK from './locale-UK.json';

export const getTranslation = () => UK;

export const TRANSLATIONS = getTranslation();
